import { Component, Input, OnInit } from '@angular/core';
import { TranslateService }         from '@ngx-translate/core';
import { UIRouter }                 from '@uirouter/core';

import { CustomerModel }        from '../customers/models/customer';
import { EditComponent }        from '../table/cell-components/actions/edit.component';
import { MessagesService }      from '../messages/messages.service';
import { Table }                from '../table/types/table';
import { TableQueryParameters } from '../table/types/table-query-parameters';
import { TableRowEvent }        from '../table/types/table-row-event';
import { TableService }         from '../table/table.service';
import { VehicleModel }         from './models/vehicle';
import { VehiclesEventModel }   from './typings/vehicles.event';
import { VehiclesService }      from './vehicles.service';

@Component({
  selector   : 'wor-vehicle-events',
  template: require('./vehicle.events.component.html')
})
export class VehicleEventsComponent implements OnInit {
  @Input() customer: CustomerModel             = {} as CustomerModel;
  @Input() events  : Array<VehiclesEventModel> = [];
  @Input() vehicle : VehicleModel              = {} as VehicleModel;

  collapsed = false;

  tableSettings : Table = {
    cache: {
      enabled: true,
      key    : this.vehiclesService.eventsTableCacheKey
    },
    columns: [
      {
        field : 'event_number',
        header: {
          text: this.translateService.instant('JS_SPACE.COLUMNS.BOOKING_NUMBER')
        },
        classes: 'all-caps'
      },
      {
        field : 'event_date',
        header: {
          text: this.translateService.instant('BOOKING_SPACE.BOOKING_DATE')
        },
        pipe: 'globalDate'
      },
      {
        field : 'event_status',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.STATUS')
        },
        pipe: 'invoiceStatus'
      },
      {
        field : 'description',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
        }
      },
      {
        field : 'total',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.TOTAL')
        },
        pipe: 'globalCurrency'
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: ( event : VehiclesEventModel ) => this.view(event)
            }
          },
          enabled: true,
          factory: EditComponent,
        },
        hideIf  : () => this.vehicle.archived,
        sortable: false,
      }
    ],
    empty: {
      text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_BOOKINGS_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : this.tableService.getCachedPaging(this.vehiclesService.eventsTableCacheKey).pageSize || 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => this.vehiclesService.getEventsCount(this.vehicle)
    },
    rows: {
      highlight: {
        enabled: true
      },
    },
    sorting: this.tableService.setSortingFromCache(this.vehiclesService.eventsTableCacheKey, {
      direction: 'desc',
      field    : 'event_date'
    })
  };

  constructor (
    private messagesService : MessagesService,
    private router          : UIRouter,
    private tableService    : TableService,
    private translateService: TranslateService,
    private vehiclesService : VehiclesService
  ) {}

  ngOnInit () : void {
    this.collapsed = !this.events.length;
  }

  get ( params : TableQueryParameters ) : Promise<Array<VehiclesEventModel>> {
    return this.vehiclesService.getEvents(this.vehicle, params)
      .then(( events : Array<VehiclesEventModel> ) => {
        this.events = events;

        return events;
      })
      .catch(error => {
        this.messagesService.error(error);

        return this.events;
      });
  }

  onRowDoubleClick ( event : TableRowEvent ) : void {
    if ( !this.vehicle.archived ) {
      this.view(event.row);
    }
  }

  view ( event : VehiclesEventModel ) : void {
    this.router.stateService.go('app.event', {
      customer_id: this.customer.id,
      id         : event.id,
      vehicle_id : event.vehicle_id
    });
  }
}
